import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors, Validators } from "@angular/forms";

@Injectable()
export class ForeignKeyValidator {
    constructor() {
    }

    static cannotBeNullOrZero(control: AbstractControl): ValidationErrors | null {
        if ((control.value == null) || (control.value as number) == 0){  
            return { cannotBeNullOrZero: true};
        }  

        return null;
    }
}